import React from 'react';
import { Router } from "@reach/router"
import Preview from './Preview';
import Page from './Page';

const App = (props) => (
  <Router>
    <Page path="/" prismicCtx={props.prismicCtx}/>
    <Preview path="/preview" prismicCtx={props.prismicCtx} />
  </Router>
);

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js